module.exports = __webpack_public_path__ + "static/okruzenje-5d90ccbc133883a64eff815c7e1e6b72.jpg";